// Which Portal environment this bundle is RUNNING on — decided by the
// host serving it, not by anything baked into the build. The staging and
// production branches converge at every merge, so a compile-time flag
// would ride along to production; the hostname can't.
const STAGING_FE_HOSTNAME = "jli-portal-fe-staging.onrender.com";

/** True when the app is being served from the staging FE host. */
export function isStagingHost(hostname: string = window.location.hostname): boolean {
    return hostname === STAGING_FE_HOSTNAME;
}
